import {Link, useLocation} from "react-router-dom";
import logo from '../assets/img/logo.png'
import {FiLogOut, FiSettings, FiVolume2, FiVolumeX} from "react-icons/fi";
import {Alert, Badge, Button, Form, Modal} from "react-bootstrap";
import './Sidebar.scss'
import {GoHomeFill} from "react-icons/go";
import {FaPlay} from "react-icons/fa6";
import {IoMdHelpCircleOutline, IoMdSchool} from "react-icons/io";
import {FaSchool} from "react-icons/fa";
import {useContext, useState} from "react";
import AppContext from "../AppContext";
import {HiBars3} from "react-icons/hi2";
import {BsChatDots} from "react-icons/bs";
import API, {HandleError} from "../API";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";
import {IoExtensionPuzzle} from "react-icons/io5";

export default function Sidebar() {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    const { enqueueSnackbar } = useSnackbar()
    const is_demo = app.user?.demo;
    const location = useLocation()
    const [showSwitchVersionModal, setShowSwitchVersionModal] = useState(false)
    const [switchForm, setSwitchForm] = useState({
        values: {
            desc: '',
            agree: false
        },
        error: false,
        loading: false
    })
    const activeClass = (path) => {
        if(location.pathname === path)
            return 'active'

        return ''
    }

    const toggleSoundFx = (e) => {
        app.toggleSoundFx()
        if(!app.ui.soundFx) {
            app.playSfxCorrect(true)
        }
    }

    const reload = () => {
        window.location.reload();
    }

    const onSwitchVersionChange = (e) => {
        let values = {...switchForm.values}
        values[e.target.name] = e.target.name === 'agree' ? e.target.checked : e.target.value;
        setSwitchForm({...switchForm, values: values})
    }
    const openSwitchVersionModal = () => {
        setShowSwitchVersionModal(true)
    }

    const closeSwitchVersionModal = () => {
        setShowSwitchVersionModal(false)
        let values = {...switchForm.values}
        values['agree'] = false;
        setSwitchForm({...switchForm, values: values})
    }
    const requestVersionSwitch = async () => {
        return false; //disabled
        app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: `/account/${app.user?.ID}/version`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {...switchForm.values}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            app.stopLoading()
            setSwitchForm({...switchForm, loading: false })
            enqueueSnackbar('Redirecting to old version...', {variant: 'success', style: {whiteSpace: 'pre-line'}});
            setTimeout(() => window.location.href = '/old-version', 1000)
        }
        catch(e) {
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <>
        <div id="sidebar-backdrop" onClick={app.toggleDrawer}></div>
        <Button id="sidebar-toggle" onClick={app.toggleDrawer}>
            <HiBars3 />
            {app.user && app.user?.extra_videos_new.length > 0 && <div className="blue-dot-indicator" />}
        </Button>
        <aside id="sidebar">
            <div className="sidebar-inner">
                <div className="main-logo">
                    {process.env.REACT_APP_IS_BETA === "true" && <div className="beta-badge">BETA</div>}
                    <Link to="/">
                        <img src={logo} alt="" />
                    </Link>
                </div>
                <div className="sidebar-scrollable">
                    {app.ui.new_version !== '' &&
                        <Alert variant="info" style={{margin: '-15px 15px 10px 15px', fontSize: 14}}>
                            <Alert.Heading style={{fontSize: 16}} className="d-flex justify-content-start gap-2 align-items-center pb-2">{t('menu.version.title')}</Alert.Heading>
                            <p>
                                {t('menu.version.text')}
                            </p>
                            <Alert.Link onClick={reload}>Klik hier <span className="fw-normal">voor de nieuwste versie!</span></Alert.Link>
                        </Alert>}
                    <nav className="main-nav">
                        <ul>
                            <li>
                                <Link to="/" className={activeClass("/")} onClick={app.closeDrawer}>
                                    <GoHomeFill /><span>{t('menu.dashboard')}</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/courses" className={activeClass("/courses")} onClick={app.closeDrawer}>
                                    <FaPlay /><span>{t('menu.videoCourses')}</span>
                                </Link>
                            </li>
                            <li className={is_demo ? 'demo-disabled' : ''}>
                                <Link to="/practice" className={activeClass("/practice")} onClick={app.closeDrawer}>
                                    <IoMdSchool /><span>{t('menu.practice')}</span>
                                </Link>
                            </li>
                            <li className={is_demo ? 'demo-disabled' : ''}>
                                <Link to="/simulation" className={activeClass("/simulation")} onClick={app.closeDrawer}>
                                    <FaSchool /><span>{t('menu.simulation')}</span>
                                </Link>
                            </li>
                            {app.user && app.user?.extra_videos_count > 0 && <li className={is_demo ? 'demo-disabled' : (app.user.extra_videos_new.length > 0 ? 'extra-videos-menu-new' : '')}>
                                <Link to="/extra-videos" className={activeClass("/extra-videos")} onClick={app.closeDrawer}>
                                    <IoExtensionPuzzle /><span>{t('menu.extraVideos')}</span>
                                    {app.user && app.user?.extra_videos_new.length > 0 ? <Badge bg="info">{app.user.extra_videos_new.length > 10 ? '10+' : app.user.extra_videos_new.length}</Badge> : null}
                                </Link>
                            </li>}
                            <li className="pt-5">
                                <Link to="/account" className={activeClass("/account")} onClick={app.closeDrawer}>
                                    <FiSettings /><span>{t('menu.account')}</span>
                                    {app.user && app.user?.pending_orders > 0 ? <Badge bg="info">{app.user.pending_orders}</Badge> : null}
                                </Link>
                            </li>
                            <li>
                                <Link to="/help" className={activeClass("/help")} onClick={app.closeDrawer}>
                                    <IoMdHelpCircleOutline /><span>{t('menu.help')}</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/logout">
                                    <FiLogOut /><span>{t('menu.logout')}</span>
                                </Link>
                            </li>

                            {/*{process.env.REACT_APP_IS_BETA === "true" && !app?.user?.demo && app.user?.multilingual != 1 &&*/}
                            {/*    <li>*/}
                            {/*        <Button onClick={openSwitchVersionModal} variant="link" className="text-decoration-none" style={{margin: '15px 0 0 0', padding: 0, fontSize: 13, textAlign: 'left'}}>*/}
                            {/*        <span className="fw-normal text-decoration-none text-muted">*/}
                            {/*            {t('menu.version.problemTitle')}*/}
                            {/*        </span>*/}
                            {/*            <br />*/}
                            {/*            {t('menu.version.problemAction')}*/}
                            {/*        </Button>*/}
                            {/*    </li>}*/}
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="sidebar-bottom">
                <div className="sound-switch">
                    <h4>{t('menu.sound')}</h4>
                    <div className="switch-inner">
                        <FiVolumeX />
                        <Form.Check type="switch" id="custom-switch" checked={app.ui.soundFx} onChange={toggleSoundFx} />
                        <FiVolume2 />
                    </div>
                </div>
            </div>
        </aside>
        {/*<Modal show={showSwitchVersionModal} onHide={closeSwitchVersionModal} className="version-switch-modal">*/}
        {/*    <Modal.Header closeButton>*/}
        {/*        <Modal.Title>*/}
        {/*            <BsChatDots />*/}
        {/*            <strong>{t('versionSwitch.title')}</strong>*/}
        {/*            <span>{t('versionSwitch.subtitle')}</span>*/}
        {/*        </Modal.Title>*/}
        {/*    </Modal.Header>*/}
        {/*    <Modal.Body className="px-5 pt-5">*/}
        {/*        <Form>*/}
        {/*            <Form.Group className="mb-3" controlId="deletionReasonDesc">*/}
        {/*                <Form.Control as="textarea" rows={4} placeholder={t('versionSwitch.placeholder')} name="desc" value={switchForm.values.desc} onChange={onSwitchVersionChange} />*/}
        {/*            </Form.Group>*/}
        {/*            <h6 className="fw-bolder mt-5">{t('nb')}:</h6>*/}
        {/*            <p style={{fontSize: 13}}>*/}
        {/*                <Trans i18nKey="versionSwitch.note" />*/}
        {/*            </p>*/}
        {/*            <div className="mt-5 mb-3" style={{fontSize: 14}}>*/}
        {/*                <Form.Check*/}
        {/*                    name="agree"*/}
        {/*                    type="checkbox"*/}
        {/*                    id="switch-account-agreement"*/}
        {/*                    label={t('versionSwitch.agree')}*/}
        {/*                    checked={switchForm.values.agree}*/}
        {/*                    value={true}*/}
        {/*                    onChange={onSwitchVersionChange}*/}
        {/*                />*/}
        {/*            </div>*/}
        {/*        </Form>*/}

        {/*    </Modal.Body>*/}
        {/*    <Modal.Footer>*/}
        {/*        <Button variant="secondary" onClick={closeSwitchVersionModal}>*/}
        {/*            {t('button.cancel')}*/}
        {/*        </Button>*/}
        {/*        <Button variant="primary" onClick={requestVersionSwitch} disabled={!switchForm.values.agree}>*/}
        {/*            {t('button.accept')}*/}
        {/*        </Button>*/}
        {/*    </Modal.Footer>*/}
        {/*</Modal>*/}
    </>
}